var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 800",
    style: {
      enableBackground: "new 0 0 1000 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "New_Symbol"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3653_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3655_",
    style: {
      fill: "#414042"
    },
    d: "M500,151.217c-137.399,0-248.783,111.384-248.783,248.783 c0,137.399,111.384,248.783,248.783,248.783S748.783,537.399,748.783,400C748.783,262.601,637.399,151.217,500,151.217z  M500,603.127c-112.184,0-203.127-90.943-203.127-203.127c0-112.184,90.943-203.127,203.127-203.127S703.127,287.816,703.127,400 C703.127,512.184,612.184,603.127,500,603.127z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3654_",
    style: {
      fill: "#414042"
    },
    d: "M514.354,426.323v-2.315V400V263.431c0-7.928-6.426-14.354-14.353-14.354 c-7.927,0-14.354,6.426-14.354,14.354v159.521l-85.363,86.419c-5.022,5.084-4.972,13.277,0.112,18.299l2.012,1.987 c5.084,5.022,13.277,4.972,18.299-0.112l89.913-91.025c2.007-2.031,3.175-4.56,3.562-7.184 C514.242,430.784,514.354,429.356,514.354,426.323z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.62e4f7cd350c3daa618aa5977c17d80c.svg";
export { ForwardRef as ReactComponent };